import { extractNumber } from '../../../../../functions/utils/extractNumber';
import { NumberInput } from '../../../baseInputs/NumberInput';

export const OpacityInput = ({
  value,
  onChange,
}: {
  value?: number;
  onChange: (newValue?: string | number) => void;
}) => {
  return (
    <NumberInput
      label="Opacity"
      value={value !== undefined ? (value * 100).toFixed(0) : 100}
      onChange={(newValue) => {
        const numberValue = extractNumber(newValue);

        newValue !== undefined && numberValue !== null && onChange((numberValue / 100).toFixed(2));
      }}
      inputStyle={{ textAlign: 'center' }}
      defaultUnit="%"
      minValue={0}
      maxValue={100}
      style={{ maxWidth: '120px' }}
    />
  );
};
